import React, { useState, useEffect } from 'react';
import { withStyles } from '@material-ui/core/styles';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Grid,
  AppBar,
  Tabs,
  Tab,
  IconButton,
  Typography,
  TextField,
  Divider,
} from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import Button from './Button';
import TabPanel from '../components/TabPanel';

import { createVirtualRoomUrl } from '../services/api';
import * as adminApi from '../services/api/admin'

function TelemedicineEditModal(props) {

  const { classes: { indent, indent2 } } = props

  const { provider, open, onClose } = props;
  const [virtualRoomUrl, setVirtualRoomUrl] = useState('');
  const [virtualRoomUrls, setVirtualRoomUrls] = useState([]);

  let tenancyWithVirtualRooms = [];
  useEffect(() => {
    (async () => {
      const newTenancies = await adminApi.fetchTenancies(provider.id)
      tenancyWithVirtualRooms = newTenancies.filter(tenancy => {
        if (tenancy) {
          if (tenancy.locationShortName && tenancy.locationShortName.toLowerCase() === 'telemedicine') {
            return tenancy.virtualRoomUrl;
          }
        }
      }, []);
      if (tenancyWithVirtualRooms) {
        setVirtualRoomUrls(tenancyWithVirtualRooms);

      }
    })();
  }, []);

  const onSaveVirtualRoomUrl = async virtualRoomUrl => {
    await createVirtualRoomUrl(provider.id, virtualRoomUrl);
    onClose();
  };
  return (
    <Dialog fullWidth open={open} onClose={onClose}>
      <DialogTitle>
        <Grid container alignItems="center">
          <Grid item xs={11} className="practiceEdit">
            <h2>{provider.name}</h2>
          </Grid>
          <Grid item xs={1}>
            <IconButton aria-label="Close" onClick={onClose}>
              <CloseIcon />
            </IconButton>
          </Grid>
        </Grid>
      </DialogTitle>

      <DialogContent>
        <AppBar position="static" color="default">
          <Tabs value={0}>
            <Tab label="Telemedicine Room Url" />
          </Tabs>
        </AppBar>

        <TabPanel>
          <Typography gutterBottom={true} color="primary">
            The following is(are) your existing Virtual Room Url(s):
          <Grid container item className={indent}>
              {virtualRoomUrls.map(room => {
                return (
                  <Typography gutterBottom={true} key={room.virtualRoomUrl}>
                    <a href="https://doxy.me/account/dashboard">
                      {room.virtualRoomUrl + `,  `}
                    </a>
                  </Typography>
                );
              })}
            </Grid>
          </Typography>

          <Typography gutterBottom={true} className={indent2} color="secondary">
            If the above is empty, create a FREE Doxy account by clicking{' '}
            <a href={`https://www.doxy.me/sign-up`} target="_blank">here</a>.
          </Typography>
          <Typography gutterBottom={true} color="primary">
            Once you have your Url, let Qwell do the rest! Copy and paste the
            link below.
          </Typography>
          <DialogContent>
            <TextField
              fullWidth
              variant="outlined"
              label="Your Doxy Room Url"
              value={virtualRoomUrl}
              onChange={event => {
                setVirtualRoomUrl(event.target.value);
              }}
            />
          </DialogContent>

          <Typography gutterBottom={true} color="primary">
            {' '}
            You can edit your appointment duration by going to Edit (button
            next to this purple one), and by going to tenancies.
          </Typography>
          <Grid container justifyContent="space-around">
            <Grid item xs={12} lg={6}>
              <Button
                onClickSuccessSnackbar="Room Url was sucessfully submitted."
                onClickFailSnackbar="Room Url could not be submitted"
                fullWidth
                color="primary"
                variant="contained"
                onClick={() => onSaveVirtualRoomUrl(virtualRoomUrl)}
              >
                Save Room Url
              </Button>
            </Grid>
          </Grid>
        </TabPanel>
      </DialogContent>
    </Dialog>
  );
}

const styles = {
  indent: {
    padding: '2em',
  },
  indent: {
    padding: '0 2em 4em 2em',
  }
}

export default withStyles(styles)(TelemedicineEditModal);
